import React from 'react';
import {
  Form, Row, Col, Input, Select, Button, Icon, DatePicker
} from 'antd';
import moment from 'moment/moment';
class EAD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values, relation: values.relation, gender: values.gender, id: this.props.item.id, first_Name: values.first_Name, middle_Name: values.middle_Name, last_Name: values.last_Name, dateOfBirth: values.dateOfBirth, plan: values.plan }, (val) => { });
      }
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      id: false
    }
  }
  componentDidMount = () => {

    const { setFieldsValue } = this.props.form;
    const { item } = this.props;
    setTimeout(() => {

      setFieldsValue({
        first_Name: item.first_Name, middle_Name: item.middle_Name, last_Name: item.last_Name, dateOfBirth: item.dateOfBirth && moment(item.dateOfBirth), relation: item.relation, gender: item.gender, plan: item.plan
      });
    }, 100);
  }
  addMemberDefaultHandler = () => {
    this.setState({ addMemberActive: !this.state.addMemberActive });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { item } = this.props;
    return (<Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
      {/* <Card> */}
      <div>
        <Row>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">First Name</legend>
                {getFieldDecorator('first_Name', {
                  rules: [{ required: true, message: 'Please enter first name' },
                  {
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                    message: "It allows only Alphabets,No whitespace at the beginning and end"
                  }],
                })(<Input type="text" className="mi_input" autoComplete={"nope"} placeholder="Enter First Name *" />
                )}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Middle Name</legend>
                {getFieldDecorator('middle_Name', {
                  rules: [{ required: false, message: 'Please enter Middle Name' },
                  {
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                    message: "It allows only Alphabets,No whitespace at the beginning and end"
                  }],
                })(<Input type="text" autoComplete={"nope"} className="mi_input" placeholder="Enter Middle Name " />)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Last Name</legend>
                {getFieldDecorator('last_Name', {
                  rules: [{ required: true, message: 'Please enter Last Name' },
                  {
                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                    message: "It allows only Alphabets,No whitespace at the beginning and end"
                  }],
                })(<Input type="text" className="mi_input" placeholder="Enter Last Name *" />
                )}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Relation</legend>
                {getFieldDecorator('relation', {
                  rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select a Relation</span> }],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input" placeholder='Please select a Relation *' style={{ marginLeft: '-11px' }} initialValue={false}>

                  <option value="Spouse">Spouse</option>
                  <option value="Child">Child</option>
                  <option value="Other Relationship">Other Relationship</option>
                </Select>)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Gender</legend>
                {getFieldDecorator('gender', {
                  rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select a Gender</span> }],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input" placeholder='Please select a Gender *' style={{ marginLeft: '-11px' }} initialValue={false}>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="NotSpecified">Not specified</option>
                </Select>)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Date of Birth</legend>
                {getFieldDecorator('dateOfBirth', {
                  rules: [{ required: true, message: 'Please enter Date of Birth' },
                  ],
                })(<DatePicker autoComplete={"nope"} format="MM/DD/YYYY" className="mi_input" disabledDate={(current) => {
                  let customDate = moment().add(1, "day").format("MM/DD/YYYY");
                  return current > moment(customDate, "MM/DD/YYYY");
                }} />
                )}
              </fieldset>
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginRight: "20px" }}>
          <Button className="mi_button_right" type="primary" htmlType="submit">
            Update
          </Button>{" "}
          <Button className="mi_button_right submit-button"
            onClick={() => { this.props.removeMember(item.id) }}
          >
            Remove
          </Button>
        </Row>
      </div>
    </Form>)
  }
}
const EditMember = Form.create()(EAD);
export default EditMember;